
import Vue from "vue"
import { mapState, mapGetters, mapActions } from "vuex"
import groupBy from "lodash/groupBy"
import eventGroups from "@/const/event-groups.json"
import type { ProgramEvent } from "@/types/api/program"
import { getBeforeAfter } from "@/utils/before-after"

export default Vue.extend({

  middleware ({ route, redirect }) {
    if (!route.query.year)
      return redirect(302, route.path, {
        ...route.query,
        year: "2024",
      })
  },

  validate ({ route }) {
    return route.params.alias in eventGroups
  },

  data: () => ({
    items: [] as ProgramEvent[],
    page: 1,
    pages: 1,
    loading: false,
  }),

  async fetch () {
    await this.fetchItems()
  },

  head () {
    return {
      // @ts-ignore
      title: this.getTitle(this.group.title),
    }
  },

  computed: {
    ...mapState("app", ["tags", "showEventsFromYear"]),
    ...mapGetters("app", ["getTitle"]),

    itemsByMonth (): Record<string, ProgramEvent[]> {
      const itemsWithDate = this.filteredItems.filter(i => i.start)

      return groupBy(itemsWithDate, (i: ProgramEvent) =>
        this.$fmt.date(i.start || 0, "LLLL"))
    },

    group (): typeof eventGroups[keyof typeof eventGroups] {
      return eventGroups[this.$route.params.alias as keyof typeof eventGroups]
    },

    tag (): string {
      return this.$route.query.tag as string || ""
    },

    lastPageReached (): boolean {
      return this.page >= this.pages
    },

    filteredItems (): ProgramEvent[] {
      return this.items
      // const { items } = this
      // return items.filter((i) => {
      //   const { type, start } = i

      //   if (type === "online") return true

      //   if (!start) return false
      //   const date = new Date(start)
      //   return date.getFullYear() >= this.showEventsFromYear
      // })
    },

    beforeAfter (): Partial<Record<string, number>> {
      const afterYear = Number.parseInt(String(this.$route.query.year))
      if (Number.isInteger(afterYear))
        return getBeforeAfter(undefined, afterYear)
      return {}
    },
  },

  watch: {
    async tag () {
      this.page = 1
      await this.$fetch()
    },
  },

  async created () {
    await this.fetchTags()
  },

  methods: {
    ...mapActions("app", { fetchTags: "FETCH_TAGS" }),

    async fetchItems (concat = false): Promise<void> {
      const { tag } = this
      const [res, err] = await this.$api.program.getEvents({
        params: {
          "filter[type]": this.$route.params.alias,
          "filter[tags]": tag ? [tag] : undefined,
          ...this.beforeAfter,
          "paginator[page]": this.page,
          "paginator[limit]": 1000,
        },
      })
      if (err) return console.error(err)
      if (!res) return

      this.pages = res.paginator.pages
      const items: ProgramEvent[] = this.$api.helpers.getList(res)

      if (concat) {
        const list = this.items
        const uniq = items
          .filter(i => !list.some(l => l.id === i.id))
        this.items = list.concat(uniq)
      } else {
        this.items = items
      }
    },

    async fetchNextPage () {
      this.loading = true
      this.page++
      await this.fetchItems(true)
      this.loading = false
    },

    onTagClick (tagId: string) {
      const { tag: currentTag } = this.$route.query
      this.$router.push({
        query: {
          ...this.$route.query,
          tag: tagId === currentTag ? undefined : tagId,
        },
      })
    },
  },
})
